import { constant, Lazy } from 'fp-ts/function';
import { ReactNode } from 'react';

export const placeholder = 'Non renseigné';
export const constPlaceholder: Lazy<ReactNode> = constant(placeholder);
